<div class="container">
    <div class="card">
        <div class="card-body">
            <div class="panel panel-primary">
                <div class="panel-heading custom-panel form-row">
                    <div class="form-group col-lg-4 col-md-4 col-sm-4 col-12">
                        <h2>Agenda Consulta Médica</h2>
                    </div>
                    <div class="menu-painel form-group col-lg-8 col-md-8 col-sm-8 col-12">
                        <button mat-stroked-button color="primary" (click)="addNovoHorarioIndividual()"
                            matTooltip="Novo Horário Indidual" [disabled]="!formularioDeAgendaConsultaMedica.valid"
                            style="margin-right: 5px; margin-bottom: 5px;">
                            Novo Horário Ind.
                        </button>
                        <button mat-stroked-button color="primary" (click)="addNovaAgenda()" matTooltip="Nova Agenda"
                            [disabled]="!formularioDeAgendaConsultaMedica.valid" 
                            style="margin-right: 5px; margin-bottom: 5px;">
                            Nova Agenda
                        </button>
                        <button mat-stroked-button color="warn" (click)="confirmDeleteLista()"
                            [disabled]="!temItemSelecionado()" matTooltip="Remover"
                            style="margin-right: 5px; margin-bottom: 5px;">Remover
                        </button>
                    </div>
                </div>

                <div class="panel-body" (window:resize)="onResize($event)">

                    <form [formGroup]="formularioDeAgendaConsultaMedica">

                        <div class="form-row">

                            <mat-form-field class="form-group col-lg-8 col-md-8 col-sm-8 col-12">
                                <mat-label>Médico</mat-label>
                                <mat-select value="Médico" formControlName="medico" name="medico" id="medico"
                                    required (selectionChange)="onChangeMedico($event)">
                                    <mat-option *ngFor="let medico of listaMedicos" [value]="medico">
                                        {{medico.nome}}
                                    </mat-option>
                                </mat-select>
                                <mat-error
                                    *ngIf="formularioDeAgendaConsultaMedica.controls.medico.hasError('required')">
                                    O campo Médico é obrigatório.
                                </mat-error>
                            </mat-form-field>

                            <mat-form-field class="form-group col-lg-4 col-md-4 col-sm-4 col-12">
                                <mat-label>Dia</mat-label>
                                <mat-select value="Dia" formControlName="diaSemana" name="diaSemana" id="diaSemana"
                                    (selectionChange)="onChangeDiaSemana($event)">
                                    <mat-option [value]=""></mat-option>
                                    <mat-option *ngFor="let diaSemana of listaDiasDaSemana" [value]="diaSemana.codigo">
                                        {{diaSemana.descricao}}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>

                        </div>

                    </form>

                    <table mat-table [dataSource]="dataSource" matSort class="table table-striped">

                        <!-- Checkbox Column -->
                        <ng-container matColumnDef="select">
                            <th mat-header-cell *matHeaderCellDef>
                                <mat-checkbox (change)="$event ? masterToggle() : null"
                                    [checked]="selection.hasValue() && isAllSelected()"
                                    [indeterminate]="selection.hasValue() && !isAllSelected()"
                                    [aria-label]="checkboxLabel()">
                                </mat-checkbox>
                            </th>
                            <td mat-cell *matCellDef="let row">
                                <mat-checkbox (click)="$event.stopPropagation()"
                                    (change)="$event ? selection.toggle(row) : null"
                                    [checked]="selection.isSelected(row)" [aria-label]="checkboxLabel(row)">
                                </mat-checkbox>
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="filial">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Filial </th>
                            <td mat-cell *matCellDef="let agendaMedica"> {{agendaMedica.nomeFilial}} </td>
                        </ng-container>

                        <ng-container matColumnDef="diaSemana">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Dia </th>
                            <td mat-cell *matCellDef="let agendaMedica"> {{agendaMedica.diaSemana | diaSemanaPipe}}
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="horaAtendimento">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Hora </th>
                            <td mat-cell *matCellDef="let agendaMedica"> {{agendaMedica.horaAtendimento |
                                horaFormatadaPipe}}
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="quantidadeAtd">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Qtd. </th>
                            <td mat-cell *matCellDef="let agendaMedica"> {{agendaMedica.quantidadeAtd}} </td>
                        </ng-container>

                        <ng-container matColumnDef="atdIdadeMinima">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Idade Mín. </th>
                            <td mat-cell *matCellDef="let agendaMedica"> {{agendaMedica.atdIdadeMinima}} </td>
                        </ng-container>

                        <ng-container matColumnDef="atdIdadeMaxima">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Idade Máx. </th>
                            <td mat-cell *matCellDef="let agendaMedica"> {{agendaMedica.atdIdadeMaxima}} </td>
                        </ng-container>

                        <ng-container matColumnDef="atdPortadorNecessidade">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Atd. PNE </th>
                            <td mat-cell *matCellDef="let agendaMedica"> {{agendaMedica.atdPortadorNecessidade |
                                simNaoPipe}} </td>
                        </ng-container>

                        <ng-container matColumnDef="details">
                            <th mat-header-cell *matHeaderCellDef class="table-column-center"> Ações </th>
                            <td mat-cell *matCellDef="let agendaMedica" class="table-column-center">
                                <button mat-icon-button color="primary" (click)="details(agendaMedica.pkAgendaMedica)"
                                    matTooltip="Detalhar">
                                    <mat-icon class="mat-18">info</mat-icon>
                                </button>
                                <button mat-icon-button color="primary" (click)="update(agendaMedica.pkAgendaMedica)"
                                    matTooltip="Alterar">
                                    <mat-icon class="mat-18">edit</mat-icon>
                                </button>
                                <button mat-icon-button color="warn"
                                    (click)="confirmDelete(agendaMedica.pkAgendaMedica)" matTooltip="Remover">
                                    <mat-icon class="mat-18">delete</mat-icon>
                                </button>
                            </td>
                        </ng-container>

                        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                    </table>
                </div>
            </div>
        </div>
    </div>
</div>